// @ts-nocheck
import {createContext,useContext} from "react";

export const AliasContext = createContext({});
export function useAlias() {
    return useContext(AliasContext);
}
